import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/queryKeys'
import { fetchLatestInsights } from '@/api/aiSummaries'

export function usePriorityInsights(): Record<string, string> | undefined {
  const { data } = useQuery({
    queryKey: queryKeys.aiSummaries.latestInsights(),
    queryFn: fetchLatestInsights,
  })
  return data
}
